// IndexedDB服务，用于持久化存储对话数据
export default {
  dbName: 'AIChatDB',
  version: 1,
  storeName: 'conversations',

  // 初始化数据库
  init() {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(this.dbName, this.version);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          // 创建存储对象，主键为id
          const objectStore = db.createObjectStore(this.storeName, { keyPath: 'id', autoIncrement: true });
          // 创建索引，方便按aiType查询
          objectStore.createIndex('by_aiType', 'aiType', { unique: false });
          // objectStore.createIndex('by_createdAt', 'createdAt', { unique: false });
        }
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve(this.db);
      };

      request.onerror = (event) => {
        console.error('IndexedDB初始化错误:', event.target.error);
        reject(event.target.error);
      };
    });
  },

  // 保存对话
  saveConversation(conversation) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      // 确保有创建时间
      if (!conversation.createdAt) {
        conversation.createdAt = new Date().toISOString();
      }
      // 更新修改时间
      conversation.updatedAt = new Date().toISOString();

      const request = store.put(conversation);

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        console.error('保存对话失败:', request.error);
        reject(request.error);
      };
    });
  },

  // 获取所有对话
  getAllConversations() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);
      const request = store.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        console.error('获取所有对话失败:', request.error);
        reject(request.error);
      };
    });
  },

  // 按AI类型获取对话
  getConversationsByAiType(aiType) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);
      const index = store.index('by_aiType');
      const request = index.getAll(aiType);
      
      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        console.error(`获取${aiType}类型对话失败:`, request.error);
        reject(request.error);
      };
    });
  },

  // 获取单个对话
  getConversationById(id) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);
      const request = store.get(id);

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        console.error(`获取ID为${id}的对话失败:`, request.error);
        reject(request.error);
      };
    });
  },

  // 删除对话
  // deleteConversation(id) {
  //   return new Promise((resolve, reject) => {
  //     const transaction = this.db.transaction([this.storeName], 'readwrite');
  //     const store = transaction.objectStore(this.storeName);
  //     const request = store.delete(id);

  //     request.onsuccess = () => {
  //       resolve(true);
  //     };

  //     request.onerror = () => {
  //       console.error(`删除ID为${id}的对话失败:`, request.error);
  //       reject(request.error);
  //     };
  //   });
  // },
  deleteConversations(ids) {
    return new Promise((resolve, reject) => {
      // 确保ids是数组，如果是单个id则转为数组
      const idsToDelete = Array.isArray(ids) ? ids : [ids];

      const transaction = this.db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      // 遍历id数组，逐个删除
      idsToDelete.forEach(id => {
        store.delete(id);
      });

      // 事务完成时的处理
      transaction.oncomplete = () => {
        resolve(true);
      };

      // 事务出错时的处理
      transaction.onerror = () => {
        console.error('批量删除对话失败:', transaction.error);
        reject(transaction.error);
      };
    });
  },

  // 清空所有对话
  clearAllConversations() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.clear();

      request.onsuccess = () => {
        resolve(true);
      };

      request.onerror = () => {
        console.error('清空所有对话失败:', request.error);
        reject(request.error);
      };
    });
  }
};
